import React, { useEffect } from 'react'

const Home = () => {
    useEffect(() => {
        document.title = "e-Book Maggioli"}, [])
    return (
        <h1>Homepage</h1>        
    )
}

export default Home